import React from "react";

import { Icon } from "../Icon";

import { ButtonStyle } from "./styles";
import { ButtonColor, ButtonSize, ButtonVariant } from "./types";

export type ButtonProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "color"> & {
  isLoading?: boolean;
  variant?: ButtonVariant;
  color?: ButtonColor;
  size?: ButtonSize;
};

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = "primary",
      color = "primary",
      size = "medium",
      isLoading,
      children,
      onClick,
      ...props
    },
    ref
  ) => {
    return (
      <ButtonStyle
        ref={ref}
        variant={variant}
        color={color}
        size={size}
        onClick={isLoading ? () => {} : onClick}
        {...props}
      >
        {isLoading ? (
          <>
            <ButtonStyle.RotatingContainer>
              <Icon name="progressActivity" />
            </ButtonStyle.RotatingContainer>
            Chargement...
          </>
        ) : (
          children
        )}
      </ButtonStyle>
    );
  }
);
